<template>
  <div class="payment-container">

    <!-- Mask -->
    <div class="mask" v-if="is_paying"></div>
    
    <!-- Payment Information -->
    <div class="payment-info" v-if="!!prod_id&&!success">
      <!-- Title -->
      <div class="header-title">
        BiblioTrees 이용권 구독 신청
      </div>

      <!-- Methods -->
      <!-- <div class="methods">
        <div class="method" v-for="(m, i) in methods" :key="i">
          <v-card flat @click="method=methods[i]" class="method-card"
            :class="{'method-card-selected': method==methods[i]}">
            <v-icon class="method-icon" 
              :class="{'method-icon-selected': method==methods[i]}">
              mdi-check-circle
            </v-icon>
            <span class="method-title">
              {{ $t('payment.'+methods[i])}}
            </span>
          </v-card>
        </div>
      </div> -->

      <!-- Payment Summary -->
      <div class="summary">
        <div class="summary-title">
          {{ $t('payment.payment_summary') }}
        </div>
        <div class="summary-contents">
          <div class="summary-details">
            {{ $t('plans.'+product.name) }} (자동결제)
          </div>
          <div class="summary-price">
            {{ $t('plans.price_'+price_unit, 
              [parseInt(product['price_'+price_unit]).toLocaleString()])}}
          </div>
        </div>
      </div>

      <div class="summary-popup">
        <v-icon small color="pms205">mdi-alert-circle</v-icon>
        <span>결제창이 뜨지 않을 경우 브라우저의 팝업을 허용해주세요.</span>
      </div>

      <div class="summary-popup" v-if="user_type=='trial'|user_type=='event'">
        <v-icon small color="pms205">mdi-alert-circle</v-icon>
        <span>무료이용기간동안({{ end_date }}까지) 프리미엄 멤버십을 언제든 해지할 수 있으며 요금이 청구되지 않습니다.</span>
      </div>

      <div class="summary-meta">
        <span>매월 동일한 날짜에 멤버십이 연장되며, 등록하신 결제 수단으로 요금이 청구됩니다. 해당 날짜가 없는 달에는 당월 말일에 결제됩니다.</span>
        <span v-html="$t('payment.commercial_terms')"></span>
      </div>

      <!-- Error -->
      <div v-if="error">
        <span class="required">
          <v-icon color="error" small>mdi-alert-circle-outline</v-icon>
          {{ $t('alert.try_again') }}
        </span>
      </div>

      <!-- Actions -->
      <div class="actions">
        <v-btn depressed dark block color="pms205" @click="pay()">
          신용카드 또는 체크카드로 신청하기
        </v-btn>
      </div>

      <div class="prev link-element">
        <div @click="prev()">
          '이용권 선택'으로 돌아가기
        </div>
      </div>

    </div>

    <!-- Success -->
    <div v-if="success">

      <div class="header-title">
        이용권 구독이 시작되었습니다!
      </div>

      <div class="header-meta" v-if="user_type=='trial'">
        {{ end_date }}까지 프리미엄 무료 사용 기간입니다.
      </div>

      <div class="header-meta">
        <div>{{ $t('payment.with_bt') }}</div>
        <div>BiblioTrees는 가로 1,000px 이상의 화면에 최적화되어 있습니다. 모바일 페이지를 선보일 예정이니 조금만 기다려주세요!😘</div>
      </div>

      <div class="actions">
        <router-link tag="div" class="btn"
          :to="{name: 'lab'}">
          <v-btn block depressed color="primary">
            {{ $t('payment.go_to_lab') }}
          </v-btn>
        </router-link>
        <router-link tag="div" class="btn"
          :to="{name: 'account'}">
          <v-btn block outlined>
            {{ $t('payment.billing_details') }}
          </v-btn>
        </router-link>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { clearInterval } from 'timers'

export default {
  props: {
    busy: {}
  },

  data() {
    return {
      prod_id: null,
      product: {},
      price_unit: 'KRW',
      methods: ['creditcard', 'mobile'],
      method: 'creditcard',
      success: false,
      error: false,
      is_paying: false,
    }
  },

  computed: {
    ...mapGetters({
      user_type: 'user/user_type',
      end_date: 'user/end_date',
      online_url: 'payment/request_online_url',
      mobile_url: 'payment/request_mobile_url',
      order_no: 'payment/request_order_no',
    }),

    is_mobile() {
      return this.$isMobile()
    },
  },

  watch: {
    online_url(val) {
      if (!this.is_mobile && !!val) {
        let vm = this
        let win = window.open(val, "", "width=450, height=600")
        // Error: 팝업창 차단
        if (win == null || typeof(win)=='undefined') {
          alert("팝업창 차단을 해제해주세요. 새로고침이 필요할 수도 있습니다.")
        }
        var close_timer = setInterval(async function() {
          if (win.closed) {
            vm.updateBusy(true)
            try {
              await vm.$store.dispatch('payment/checkRequestPayletter', {
                order_no: vm.order_no
              })
            } catch(e) {
              window.clearInterval(close_timer)
              vm.is_paying = false
              alert('에러가 발생했습니다.')
            } finally {
              let status = vm.$store.getters['payment/request_check_status']
              window.clearInterval(close_timer)
              vm.is_paying = false
              vm.updateBusy(false)
              if (status == 6) {
                alert('자동결제 등록이 취소되었습니다.')
              }
              else if (status == 7) {
                vm.success = true
              }
              else {
                alert('자동결제 등록 중 오류가 발생했습니다. 다시 시도해주세요.')
              }
            }
          }
        }, 1000)
      }
    },

    mobile_url(val) {
      if (this.is_mobile&&!!val) {
        let vm = this
        let win = window.open(val, "_blank")
        var close_timer = setInterval(async function() {
          if (win.closed) {
            vm.updateBusy(true)
            try {
              await vm.$store.dispatch('payment/checkRequestPayletter', {
                order_no: vm.order_no
              })
            } catch(e) {
              window.clearInterval(close_timer)
              vm.is_paying = false
              alert('에러가 발생했습니다.')
            } finally {
              let status = vm.$store.getters['payment/request_check_status']
              window.clearInterval(close_timer)
              vm.is_paying = false
              vm.updateBusy(false)
              if (status == 6) {
                alert('자동결제 등록이 취소되었습니다.')
              }
              else if (status == 7) {
                vm.success = true
              }
              else {
                alert('자동결제 등록 중 오류가 발생했습니다. 다시 시도해주세요.')
              }
            }
          }
        }, 1000)
      }
    },

    error(val) {
      if (val) {
        window.close()
      }
    },
  },

  async created() {
    let vm = this
    let error = false
    this.updateBusy(true)
    this.$store.commit('payment/setRequestOnlineURL', null)
    this.$store.commit('payment/setRequestMobileURL', null)
    this.$store.commit('payment/setRequestOrderNo', null)
    this.$store.commit('payment/setRequestCheckStatus', null)
    try {
      await this.$store.dispatch('welcome/getProducts')
    } 
    catch(e) {
      error = true
      let status = !!e.response ? e.response.status : '000'
      this.$store.commit('error/setErrorCode', status)
      this.$store.commit('error/setDialog', true)
    }
    finally {
      if (!error) {
        let all_prods = this.$store.getters['welcome/products']
        this.prod_id = this.$store.getters['welcome/prod_id']
        this.product = all_prods.find(v => v.prod_id == vm.prod_id)
      }
      this.updateBusy(false)
    }
  },

  methods: {
    updateBusy(state) {
      this.$emit('update:busy', state)
    },

    prev() {
      this.$router.push({name:'signupform', params: {code: 'plans'}})
    },

    async pay() {
      this.$analytics.logEvent('click', { name: 'payment_btn_pay' })
      this.is_paying = true
      this.error = false
      try {
        await this.$store.dispatch('auth/updateToken')
        await this.$store.dispatch('payment/requestPayletter', {
          product: this.prod_id,
          pgcode: this.method,
        })
      } catch(e) {
        this.error = true
      } finally {
        if (this.error) {
          this.is_paying = false
        }
      }
    },
  },
}
</script>

<style scoped>
  .header-title {
    padding: 10px 0 20px;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .header-meta {
    font-size: 14px;
    text-align: center;
  }

  .header-meta > div {
    margin-bottom: 12px;
  }

  .methods {
    display: grid;
    grid-template-columns: 48% 48%;
    grid-column-gap: 4%;
  }

  .method-card {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    border: #B3A8B5 2px solid !important;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .method-card-selected {
    border: #BFD833 2px solid !important;
    color: #BFD833 !important;
  }

  .method-icon {
    color: #B3A8B5;
    font-size: 20px;
    margin-right: 5px;
  }

  .method-icon-selected {
    color: #BFD833 !important;
  }

  .summary {
    display: flex;
    flex-direction: column;
    margin: 20px 0 20px;
  }

  .summary-title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .summary-contents {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
  }

  .summary-details {
    color: #676168;
  }

  .summary-price {
    font-size: 20px;
  }

  .summary-popup {
    font-size: 14px;
    margin: 24px 0 14px;
  }

  .summary-meta {
    font-size: 13px;
    margin: 14px 0 32px;
  }

  .prev {
    margin-top: 20px;
    text-align: end;
  }

  .actions .btn {
    margin-top: 20px;
  }

  .mask {
    cursor: pointer;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(33,33,33,0.46);
    z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared_components/form/PaymentAuto.vue